// badges
export const badgeUuids = {
  BADGE_4_DAYS_WEEK_UUID: 'bf0ebe8d-4852-4ff9-8b84-48572678a27a',
  BADGE_AGC_UUID: '2748a716-0de4-48f0-8315-c9ac4d9d352a',
  BADGE_ASSOCIATION_UUID: 'adc36374-9fd7-4d65-93e8-3b22a629a1d8',
  BADGE_AUDIT_EXPERTISE_UUID: 'c7c8943d-0a3b-4cc5-8bbf-c769c97bb8bc',
  BADGE_BALANCE_UUID: 'b35d64ee-d6a9-4c9a-814c-82b596887186',
  BADGE_CAFE_UUID: '2fb062b3-7668-44c5-8eb3-317798da2651',
  BADGE_CLOCK_UUID: 'b0512259-905b-4bfe-ac30-b7037260adea',
  BADGE_DEC_UUID: '77bf00ec-2313-4a48-aaae-f0575ea58fb3',
  BADGE_HALF_TIME_UUID: '92829b0b-6bcf-4cca-a063-fbdba657ddaf',
  BADGE_HANDI_ACCUEILLANT_UUID: 'a9548dd5-5844-45ff-9309-6ab52849ce26',
  BADGE_HOME_OFFICE_UUID: '2c9e0687-5d92-44eb-bcde-e19b4db1178e',
  BADGE_INTERNATIONAL_UUID: 'c5b46a89-675c-4e98-820d-4186895d73cc',
  BADGE_NO_COSTUME_UUID: '205d1a92-678e-4033-b996-9f41e1678a18',
  BADGE_PARKING_UUID: 'fd832605-a4f5-40ea-960b-74aec52ad0b7',
  BADGE_RSE_UUID: 'dd2371fa-40e4-422c-a490-44bd762dc7a2',
  BADGE_SPORT_UUID: '487fa6ca-abac-4935-9693-1b7810ee525a',
  BADGE_STAGES_UUID: '8de8edcf-d6e8-49c1-9118-fd7446ad368f',
  BADGE_TEAM_BUILDING_UUID: '5d32a092-53fc-4fa7-a9b9-f4b2c7e4a628',
  BADGE_TELEWORK_UUID: 'a1ea7256-6106-4184-b35c-17dabc23baea',
  BADGE_VELO_UUID: 'ab58942f-fcf9-4093-a126-a1cee01e6a85',
  BADGE_FOUR_DAYS_AND_HALF_UUID: '2e1a0c25-5eff-47da-b52a-67580d798938',
}

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const IGNORED_FIRM_UUIDS = [
  '69f55f13-6ae4-494b-85f0-09cf9a4931de',
  'ddb35fdc-65d0-46e2-a262-b55eb383a35c',
]

export const API_URL = process.env.CORE_STRAPI_URL

export const PRIMARY_COLORS = [
  'night',
  'primary',
  'lama-green',
  'lama-yellow',
  'lama-red',
]

export function getRandomPrimaryColor() {
  return PRIMARY_COLORS[Math.floor(Math.random() * PRIMARY_COLORS.length)]
}
